/**
 * Workspace Clipboard — persistent working text.
 * Capture output from any tool, use it as input in another.
 * Pure localStorage storage layer. UI lives in the Sessions drawer.
 */

import { safeGetItem, safeSetItem } from './utils/storage.js';

const STORAGE_KEY = 'unveil:workspace';

/** Read the current workspace text (may be empty string). */
export function getWorkspaceText() {
  return safeGetItem(STORAGE_KEY, '');
}

/**
 * Save text to the workspace clipboard.
 */
export function captureToWorkspace(text) {
  if (!text) return;
  return safeSetItem(STORAGE_KEY, text, 'Workspace could not be updated. Local storage may be full.');
}

/** Clear workspace text. */
export function clearWorkspace() {
  return safeSetItem(STORAGE_KEY, '', 'Workspace could not be cleared. Local storage may be full.');
}
